import { Component, inject, input, output, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'app-header-toolbar',
  standalone: true,
  imports: [
    AvatarModule,
    BadgeModule,
    ButtonModule,
    PopoverModule,
    RouterLink,
    TranslateModule,
  ],
  templateUrl: './header-toolbar.component.html',
})
export class HeaderToolbarComponent {
  readonly username = input<string>('User');
  readonly appShortName = input<string>('M');
  readonly profileImageUrl = input<string | null>(null);
  readonly version = input<string>('');
  readonly versionDate = input<string>('');
  readonly envLabel = input<string>('SANDBOX');

  isSidebarVisible = signal(false);
  readonly isAuthenticated = input<boolean>(false);

  readonly logout = output<void>();
  readonly login = output<void>();

  private readonly translate = inject(TranslateService);

  currentYear(): number {
    return new Date().getFullYear();
  }

  usernameInitials(): string {
    const value = this.username().trim();
    if (!value) {
      return '?';
    }

    const parts = value.split(/\s+/);
    if (parts.length === 1) {
      return value.substring(0, 2).toUpperCase();
    }

    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  getProfileImageUrl(): string {
    return this.profileImageUrl() ?? "";
  }

  toggleSidebar(): void {
    this.isSidebarVisible.update(value => !value);
  }

  closeSidebar(): void {
    this.isSidebarVisible.set(false);
  }

  toggleUserMenu(event: Event, op: { toggle: (e: Event) => void }): void {
    op.toggle(event);
  }

  onLogout(op: { hide: () => void }): void {
    op.hide();
    this.logout.emit();
  }

  onLogoutFromMobile(): void {
    this.closeSidebar();
    this.logout.emit();
  }
}


